export const  TiposSplitEnum  = Object.freeze({
  CREACION: 1,
  EDICION: 2,
})